import { matchPath, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { applySeo, SITE_NAME, SITE_URL } from "./useSeo";

// Default SEO per route. Detail pages (product/news/album) override this
// with their own useSeo() call once data has loaded.
const ROUTES = [
  { path: "/", titleKey: null, home: true },
  { path: "/home", titleKey: null, home: true, canonical: "/" },
  { path: "/catalog", titleKey: "nav.catalog" },
  { path: "/news", titleKey: "nav.news" },
  { path: "/gallery", titleKey: "nav.gallery" },
  { path: "/login", titleKey: "nav.login", noindex: true },
  { path: "/register", titleKey: "nav.register", noindex: true },
  // Detail pages: placeholder until the component sets real data.
  { path: "/product/:slug", detail: true },
  { path: "/news/:id", detail: true },
  { path: "/gallery/:id", detail: true },
];

const RouteSeo = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);

  useEffect(() => {
    const route = ROUTES.find((r) => matchPath({ path: r.path, end: true }, pathname));
    if (route && route.detail) return; // detail component owns its SEO

    if (!route) {
      // Private / admin / cart / profile pages and unknown URLs: keep out of the index.
      applySeo({ noindex: true, lang });
      return;
    }

    applySeo({
      title: route.titleKey ? t(route.titleKey) : null,
      canonical: route.canonical,
      noindex: !!route.noindex,
      lang,
      jsonLd: route.home
        ? {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: SITE_NAME,
            url: SITE_URL + "/",
          }
        : undefined,
    });
  }, [pathname, t, lang]);

  return null;
};

export default RouteSeo;
